module.exports = __webpack_public_path__ + "static/Chicory5-c03a43f97d4077fb24834c3b5e1c59ed.png";